<template>

<Perfiles></Perfiles>

</template>


<script>

import Perfiles from '../../components/Perfiles.vue';

export default {


 components:{

     Perfiles

  }

}


</script>